import { render, staticRenderFns } from "./SearchIcon.vue?vue&type=template&id=25ef7b1e&scoped=true"
import script from "./SearchIcon.vue?vue&type=script&lang=js"
export * from "./SearchIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ef7b1e",
  null
  
)

export default component.exports